import { getEffectiveMonthYear } from '@utils/effectiveMonthYear';

const useMeterReadDetailsTableMonthCell = ({ id, data, editable, isEditable: isEditableProp, retroInput = false }) => {
  if (!data) {
    return {
      id,
      data,
      isEffectiveMonth: false,
      isEditable: false,
      isReadonly: false,
    };
  }

  const effectiveMonthYear = getEffectiveMonthYear();

  const isEffectiveMonth = data.month_year === effectiveMonthYear;

  // Retro input rows are editable for all past months (not just the current month)
  const isPastMonth = data.month_year != null && data.month_year < effectiveMonthYear;
  const isEditable = editable !== false && !data.readonly &&
    (retroInput ? isPastMonth : isEffectiveMonth) &&
    isEditableProp !== false;

  return {
    id,
    data,
    isEffectiveMonth,
    isEditable,
    isReadonly: data.readonly || false,
  };
};

export default useMeterReadDetailsTableMonthCell;
